export const todoRoleTabConfig = {
    'CALL CENTER': {
        visibleTabIndices: [1, 2],
        canRequestTask: true,
        taskType: 'callCenter'
    },
    'HEAD CALL CENTER': {
        visibleTabIndices: [1, 2],
        canRequestTask: true,
        taskType: 'headCallCenter'
    },
    'APPRAISER': {
        visibleTabIndices: [2],
        canRequestTask: true,
        taskType: 'appraiser'
    },
    'HEAD APPRAISER': {
        visibleTabIndices: [2],
        canRequestTask: true,
        taskType: 'headAppraiser'
    },
    'ACCOUNTING': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'HEAD ACCOUNTING': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'POWER OF ATTORNEY REGISTRATION': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'DOCUMENT REQUEST': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'INSURANCE': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'LAWYER': {
        visibleTabIndices: [2],
        canRequestTask: false
    },
    'ARBITRATION LAWYER': {
        visibleTabIndices: [6, 7, 8, 10],
        canRequestTask: false
    },
    'ENFORCEMENT PROCESSORS': {
        visibleTabIndices: [8],
        canRequestTask: false
    },
    'HEAD ENFORCEMENT': {
        visibleTabIndices: [8, 9],
        canRequestTask: false
    },
    'COMPENSATION OFFICER': {
        visibleTabIndices: [8, 9],
        canRequestTask: false
    },
    'MANAGEMENT': {
        visibleTabIndices: [0, 5, 6, 7, 8, 9, 10],
        canRequestTask: false
    },
    'COORDINATOR': {
        visibleTabIndices: [0, 5, 6, 7, 8, 9, 10],
        canRequestTask: false
    },
    'ADMIN': {
        visibleTabIndices: [0, 5, 6, 7, 8, 9, 10],
        canRequestTask: false
    },
    DEFAULT: { visibleTabIndices: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], canRequestTask: false }
};

export const getTodoRoleConfig = (userRole) => todoRoleTabConfig[userRole] || todoRoleTabConfig.DEFAULT;

export const getVisibleTodoTabs = (categories, userRole) => {
    const roleConfig = getTodoRoleConfig(userRole);
    return categories.filter((category, index) => roleConfig.visibleTabIndices.includes(index));
};

export const getDefaultTodoActiveTabId = (categories, userRole) => {
    const visibleTabs = getVisibleTodoTabs(categories, userRole);
    return visibleTabs.length > 0
        ? (categories.findIndex(cat => cat.title === visibleTabs[0].title) + 1).toString()
        : '1';
};

export const todoRoleStateFilterConfig = {
    'CALL CENTER': ['Düzeltme Bekleniyor'],
    'HEAD CALL CENTER': ['Düzeltme Bekleniyor'],
    'APPRAISER': ['Eksper Onay Bekleniyor', 'Eksper İşlem Bekleniyor', 'Yeni Eksper İşlem Bekleniyor', 'Eksper Rapor Bekleniyor', 'Yeni Eksper Rapor Bekleniyor'],
    'HEAD APPRAISER': ['Eksper Onay Bekleniyor', 'Eksper İşlem Bekleniyor', 'Yeni Eksper İşlem Bekleniyor', 'Eksper Rapor Bekleniyor', 'Yeni Eksper Rapor Bekleniyor'],
    'ACCOUNTING': ['Eksper Raporu Ödeme Bekleniyor', 'Yeni Eksper Raporu Ödeme Bekleniyor'],
    'HEAD ACCOUNTING': ['Ödeme Bekleniyor', 'Eksper Raporu Ödeme Bekleniyor', 'Yeni Eksper Raporu Ödeme Bekleniyor'],
    'POWER OF ATTORNEY REGISTRATION': ['Vekalet Bekleniyor'],
    'DOCUMENT REQUEST': ['Evrak Bekleniyor'],
    'INSURANCE': ['Sigorta Başvuru Dilekçe Bekleniyor', 'Yeni Sigorta Başvuru Dilekçe Bekleniyor', 'Ekspersiz Yeni Sigorta Başvuru Dilekçe Bekleniyor', 'İcra Sürecine Yönlendirildi'],
    'ENFORCEMENT PROCESSORS': [],
    'HEAD ENFORCEMENT': [],
};

export const getTodoRoleStateFilters = (userRole) => todoRoleStateFilterConfig[userRole];
